module.exports = __webpack_public_path__ + "static/media/4.baf9e0f0.jpg";